import React, {useEffect, useRef, useState} from 'react';
import main_block_bg from "./images/main_page_bg.svg";
import Header from "../components/Header";
import main_bg from "./images/main_bg.png";
import problems_icon1 from "./images/problems_point_icon1.svg";
import problems_icon2 from "./images/problems_point_icon2.svg";
import problems_icon3 from "./images/problems_item_icon3.svg";
import founder_photo from "./images/founder_photo.png";
import circles_bg from "./images/circles.svg";
import connect_icon1 from "./images/connect_icon1.svg";
import connect_icon2 from "./images/connect_icon2.svg";
import connect_icon3 from "./images/connect_icon3.svg";
import connect_icon4 from "./images/connect_icon4.svg";
import footer_logo from "./images/present_footer_logo.svg";
import white_logo from "./images/white_logo.svg";
import big_roadmap from "./images/big_roadmap.svg";
import favicon from "./images/favicon.png";
import "./presentation.css"
import {motion} from "framer-motion";
import { Helmet } from 'react-helmet';
import Roadmap from "../components/ImprovedRoadmap";
import DevelopmentButton from "../components/DevelopmentButton";

const Presentation = () => {
   /* useEffect(() => {
        if (window.location.hostname === "localhost") {
            window.location.href = "https://info.undura.com/presentation";
        }
    }, []);*/

    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpanded1, setIsExpanded1] = useState(false);
    const wrapperRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.pageX - wrapperRef.current.offsetLeft;
        scrollLeft.current = wrapperRef.current.scrollLeft;
    };

    const onMouseMove = (e) => {
        if (!isDragging.current) return;
        const x = e.pageX - wrapperRef.current.offsetLeft;
        const walk = x - startX.current;
        wrapperRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const onMouseUp = () => {
        isDragging.current = false;
    };
    const toggleDescription = () => {
        setIsExpanded(!isExpanded);
    };
    const toggleDescription1 = () => {
        setIsExpanded1(!isExpanded1);
    };
    const descClasses = `problems_desc ${isExpanded ? 'expanded' : ''}`;
    const descClasses1 = `problems_desc ${isExpanded1 ? 'expanded' : ''}`;

    const initial = {opacity: 0, y: 40}
    const whileInView = {opacity: 1, y: 0}
    const transition = {duration: 0.8, ease: "easeOut", delay:0.1}
    const viewport = {once: true}

    const roadmap = [
        { label: "Compilation and verification of documentation: KYC/KYB/AML policies, conflict-of-interest management (Art. 8), KIIS/disclosures, marketing fairness and clarity, agreements with EMI/PI, continuity plan and backup-servicer arrangement (Art. 12), GDPR compliance framework.\n" +
                "Pre-licensing consultations and submission of the application package.", date: "ECSPR: Preparation and Application in Lithuania", branch: "up",  open: true},

        { label: "Completion of the Lite Hub UI and connection to the underlying infrastructure: multi-tenant architecture, Undura ID, transparent non-security donation flows, and recipient reporting.", date: "Launch of Lite Interface and Hub", branch: "down" },
        { label: "Definition of service perimeter (e.g., order reception and transmission, secondary layer), best-execution policy, product and client categorization, transaction reporting procedures (RTS/ITS), capital and competency requirements. Compilation of evidence and submission for authorization.", date: "MiFID II: Preparation and Application in Germany" , branch: "up", open: true},
        { label: "Finalization of the core modules: Risk & Compliance, Data Integrity, Continuity & Custody, Settlement & Ledger, Growth & Competence, API & Expansion.\n" +
                "Integration with KYC/EMI providers, resilience testing (RPO/RTO), audit trails, penetration testing, target SLO/SLA.\n" +
                "Preparation for operational and regulatory audits.", date: "Completion of Core and Hub Development" , branch: "down", open: true},
        { label: "Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, expansion of Settlement & Ledger Core. Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, and expansion of the Settlement & Ledger Core. Completion and testing of the secondary market layer, followed by its official launch after obtaining the MiFID II license.", date: "MiFID Modules and Secondary Market" , branch: "up"},
        { label: "Technical and legal feasibility study of compatibility: fund structures and risk management (AIFM), financial data access and exchange (FiDA).\n" +
                "Design of adapters, prototype reporting schemes, and data interface alignment.", date: "Research of AIFM and FiDA Modules" , branch: "down", open: true},
        { label: "Localization for neighboring jurisdictions: partnerships with local EMI/KYC providers, data storage and compliance requirements, mapping of reporting and legal structures. Gradual rollout of white-label network nodes in non-EU markets.", date: "Expansion Beyond the EU" , branch: "up"},
    ];
    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };


    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }


    useEffect(() => {
        document.body.classList.add("no-smooth");
        document.documentElement.classList.add("no-smooth"); // <html>

        return () => {
            document.body.classList.remove("no-smooth");
            document.documentElement.classList.remove("no-smooth");
        };
    }, []);


    return (
        <div className="presentation_page">

            <Helmet>

                <title>Presentation | Undura</title>
                <meta name="title" content="Presentation | Undura" />
                <meta name="description" content="We build regulatory infrastructure under ECSPR and MiFID that helps companies raise capital and create their own branded fundraising platforms." />

                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:title" content="Presentation | Undura" />
                <meta property="og:description" content="We build regulatory infrastructure under ECSPR and MiFID that helps companies raise capital and create their own branded fundraising platforms." />
                <meta property="og:image" content="https://undura.com/favicon.png" />

                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content={window.location.href} />
                <meta property="twitter:title" content="Presentation | Undura" />
                <meta property="twitter:description" content="We build regulatory infrastructure under ECSPR and MiFID that helps companies raise capital and create their own branded fundraising platforms." />
                <meta property="twitter:image" content="https://undura.com/favicon.png" />

            </Helmet>
            <motion.img src={main_block_bg} alt="" className="main_block_bg" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}/>
            <Header mode = "presentation"/>

            <motion.div className="powered_by" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <div className="circle"></div>
                Powered by Undura
            </motion.div>
            <motion.div className="main_text" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                Turning Regulation into <span>a Tool</span>,<br/> not <span>a Barrier</span>.
            </motion.div>
            <motion.div className="about_undura_main" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                We build regulatory infrastructure under ECSPR and MiFID that helps companies raise
                capital and create their own branded fundraising platforms.
            </motion.div>
            <motion.div className="main_block_buttons" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <DevelopmentButton className="get_started pos_center_popup">
                    System Overview
                </DevelopmentButton>
                <DevelopmentButton className="explore_demo">
                    View Resources
                </DevelopmentButton>
            </motion.div>


            <a id="problem"></a>
            <motion.div className="main_bg_block" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <img src={main_bg} alt="" className="main_bg"/>
            </motion.div>

            <motion.div className="presentation_block_theme" initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}>
                Problem — Barriers that stop innovation
            </motion.div>
            <motion.div className={descClasses} initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}>
                When a company tries to build its own fundraising or investment platform, it quickly meets a wall — high
                entry barriers and strict regulatory limits.
                <br/>
                <br/>
                With my first project, BrixWise, a real-estate investment platform, the issue was clear.
                If we worked under someone else’s licence, the cost would destroy the economic model.
                If we tried to get our own licence, we faced Article 8 of the ECSPR regulation, which forbids licence
                holders from offering their own projects.
                Moving to a MiFID II licence could remove that limit — but the entry cost is so high that only large
                corporations can afford it.
                <br/>
                <br/>
                The current market structure paralyses innovation in the financial and securities sector.
                Startups and SMEs that want to experiment with new investment models simply can’t do it — there is no
                practical tool that lets them test innovation safely and legally in the real market.
                <br/>
                <br/>
                Regulatory sandboxes appeared as an answer to this problem, allowing limited testing environments for
                new financial ideas.
                However, their progress is slow — companies must first complete sandbox testing and only then move to
                the real market, and even then, not all models work as intended.
                The same issue that stopped BrixWise — like Article 8 under ECSPR — still applies.
                <br/>
                <br/>
                Recognising these limits, regulators introduced a new concept: outcome-based regulation, focusing on
                protecting stakeholders rather than enforcing rigid rules.
                But the transition is slow.
                Many companies are still afraid of the older rule-based and principle-based systems — and that fear
                continues to hold back innovation.


            </motion.div>
            <motion.div className="problems_read_more" onClick={toggleDescription} initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}>
                {isExpanded ? "Read less" : "Read more"}
            </motion.div>

            <div className="problems_points">
                <div className="problems_three_points">
                    <motion.div className="problems_point" initial={initial}
                                whileInView={whileInView}
                                transition={transition}
                                viewport={viewport}>
                        <div
                            className="problems_icon_block">
                            <img src={problems_icon1} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Complex Access to Capital
                        </div>
                        <div className="problems_item_desc">
                            SMEs and startups face high costs and complex compliance to enter the market.
                        </div>
                    </motion.div>

                    <motion.div className="problems_point" initial={initial}
                                whileInView={whileInView}
                                transition={transition}
                                viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon2} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Innovation Paralysis
                        </div>
                        <div className="problems_item_desc">
                            Licensing barriers stop companies from testing their own financial products.
                        </div>
                    </motion.div>

                    <motion.div className="problems_point" initial={initial}
                                whileInView={whileInView}
                                transition={transition}
                                viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon3} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Sandbox Limitations
                        </div>
                        <div className="problems_item_desc">
                            Regulatory sandboxes help — but progress is too slow for real innovation.
                        </div>
                    </motion.div>
                </div>
                <a id="solution"></a>
                <div className="problems_two_points">
                    <motion.div className="problems_point" initial={initial}
                                whileInView={whileInView}
                                transition={transition}
                                viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon1} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Fear of Regulation
                        </div>
                        <div className="problems_item_desc">
                            Rule-based systems make companies afraid to experiment.
                        </div>
                    </motion.div>

                    <motion.div className="problems_point" initial={initial}
                                whileInView={whileInView}
                                transition={transition}
                                viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon2} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Need for Outcome-based Tools
                        </div>
                        <div className="problems_item_desc">
                            Innovation should be measured by protection and transparency, not paperwork.
                        </div>
                    </motion.div>
                </div>
            </div>

            <motion.div className="presentation_block_theme taleft" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                Solution — Turning regulation into an instrument for innovation
            </motion.div>
            <motion.div className={`${descClasses1} taleft`} initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                Undura was created to remove these barriers and make innovation possible within regulation.
                Instead of treating compliance as a limitation, we turn it into a framework that supports safe
                experimentation.
                <br/>
                <br/>
                Undura builds a unified infrastructure under ECSPR and MiFID II that allows companies to launch their
                own branded fundraising or investment platforms — without the need to become licensed financial
                institutions themselves.
                <br/>
                <br/>
                The system monitors compliance automatically, evaluates outcomes, and ensures that every platform
                protects its investors and meets EU regulatory standards.
                If an offer meets the required level of transparency and consumer protection, Undura approves it for
                launch.
                If it doesn’t, the system points out the issues that need to be fixed.
                <br/>
                <br/>
                This model transforms the idea of compliance from rule-based control to outcome-based trust.
                Regulators get measurable evidence of safety and fairness.
                Companies get the freedom to build and test new financial models without fear of crossing invisible
                lines.
                <br/>
                <br/>
                With Undura, innovation doesn’t have to wait for regulation to change —
                it grows inside it.

            </motion.div>

            <motion.div className="problems_read_more taleft" onClick={toggleDescription1} initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                {isExpanded1 ? "Read less" : "Read more"}
            </motion.div>
            <div className="mobile_only">
                <div className="problems_three_points">
                    <motion.div className="problems_point" initial={initial}
                         whileInView={whileInView}
                         transition={transition}
                         viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon1} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Regulation should protect people, not slow progress.
                        </div>
                    </motion.div>

                    <motion.div className="problems_point" initial={initial}
                         whileInView={whileInView}
                         transition={transition}
                         viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon2} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Innovation should grow inside the system, not outside it.
                        </div>
                    </motion.div>

                    <motion.div className="problems_point" initial={initial}
                         whileInView={whileInView}
                         transition={transition}
                         viewport={viewport}>
                        <div className="problems_icon_block">
                            <img src={problems_icon3} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            Undura turns compliance into collaboration — enabling real-world
                            experimentation within regulation.
                        </div>
                    </motion.div>
                </div>
            </div>

            <a id="tracks"></a>
            <motion.div className="undura_solution" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <img src={white_logo} alt=""/>
                <div className="undura_solution_desc">
                    Regulation should protect people, not slow progress.
                    <br/>
                    <br/>
                    Innovation should grow inside the system, not outside it.
                    <br/>
                    <br/>
                    Undura turns compliance into collaboration — enabling real-world experimentation within regulation.
                </div>
            </motion.div>

            <motion.div className="main_text" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                Two Tracks
            </motion.div>
            <motion.div className="about_undura_main" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                One infrastructure, two regulatory paths.
            </motion.div>

            <div className="two_tracks_points">
                <motion.div className="tracks_point" initial={initial}
                     whileInView={whileInView}
                     transition={transition}
                     viewport={viewport}>
                    <div className="two_tracks_icon">
                        <img src={problems_icon1}/>
                        <div className="tracks_number">
                            01
                        </div>
                    </div>
                    <div className="tracks_name">
                        Lite — Donation & Support Core
                    </div>
                    <div className="tracks_desc">
                        A lightweight parallel track built on similar operational principles as Core. Focused on
                        donations, grants, and non-investment support. Designed to demonstrate how multi-tenant systems
                        can operate transparently while Core progresses toward ECSP authorization.
                        <br/>
                        <br/>
                        • Transparent, traceable fund flows (non-security).<br/>
                        • Shared identity layer (Undura ID) with optional risk-based KYC.<br/>
                        • Recipient dashboards and public transparency reports.<br/>
                        • Fast onboarding for pilots and community projects.<br/>
                        • Clear infrastructure evolution to Core when regulatory conditions are met.<br/>
                    </div>
                    <div className="view_lite_button">
                        View Lite Overview
                    </div>
                </motion.div>

                <motion.div className="tracks_point" initial={initial}
                     whileInView={whileInView}
                     transition={transition}
                     viewport={viewport}>
                    <div className="two_tracks_icon">
                        <img src={problems_icon2}/>
                        <div className="tracks_number">
                            02
                        </div>
                    </div>
                    <div className="tracks_name">
                        Core — Regulated Investment Core
                    </div>
                    <div className="tracks_desc">
                        The primary track for regulated fundraising and securities issuance. Built for ECSPR v1.0
                        authorization and aligned with MiFID II. Supports the operational stack required for loans,
                        bonds, and equity under ECSPR scope, with a roadmap to secondary‑market capabilities.
                        <br/>
                        <br/>
                        • Risk & Compliance Core (KYC/KYB/AML, conflicts under Art. 8).<br/>
                        • Data Integrity & immutable audit records (GDPR‑aligned).<br/>
                        • Payments & Escrow via licensed EMI/PI; Settlement & Ledger.<br/>
                        • Investor knowledge tests, cooling‑off, standardized disclosures.<br/>
                        • API‑first operations and regulatory reporting (NCA/ESMA)
                    </div>
                    <div className="view_lite_button">
                        View Lite Overview
                    </div>
                </motion.div>
            </div>

            <motion.div className="main_text" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <span>Vision</span> Roadmap
            </motion.div>
            <motion.div className = "roadmap_fs_block" initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}
                        ref={wrapperRef}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseUp}
                        onMouseUp={onMouseUp}
                        style={{
                                overflowX: "auto !important",
                                overflowY: "hidden",
                                cursor: isDragging.current ? "grabbing" : "grab"
            }}
            >
                <Roadmap items={roadmap} />
            </motion.div>
            {/*<motion.div className="big_roadmap" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>
                <img src={big_roadmap} alt=""/>
            </motion.div>*/}
            <a id="contact"></a>
            <motion.div className="connect_bg_block" initial={initial}
                 whileInView={whileInView}
                 transition={transition}
                 viewport={viewport}>

                <div className="connect_undura">
                    <div className="connect_info">
                        <div className="connect_name">
                            Connect
                        </div>
                        <div className="connect_desc">
                            For direct communication regarding partnerships, licensing, infrastructure
                            collaboration, or other inquiries, please reach out to:
                        </div>
                        <div className="founder_block">
                            <div className="founder_photo">
                                <img src={founder_photo} alt=""/>
                            </div>
                            <div className="founder_info">
                                <div className="founder_name">
                                    Ivan Negoda
                                </div>
                                <div className="founder_head">
                                    Founder & Head of Business
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="presentation_society_block">

                        <div className="presentation_society_item">
                            <div className="society_name">
                                <img src={connect_icon1} alt=""/>
                                Mail
                            </div>
                            <div className="society_link">
                                <a href="mailto:founder@undura.com">
                                    founder@undura.com
                                </a>
                            </div>
                        </div>

                        <div className="presentation_society_item">
                            <div className="society_name">
                                <img src={connect_icon2} alt=""/>
                                WhatsApp
                            </div>
                            <div className="society_link">
                                <a href="https://wa.me/353851093899">
                                    +353 851 093 899
                                </a>
                            </div>
                        </div>

                        <div className="presentation_society_item">
                            <div className="society_name">
                                <img src={connect_icon3} alt=""/>
                                Website
                            </div>
                            <div className="society_link">

                                <a href="https://undura.com/" target = "_blank">
                                    www.undura.com
                                </a>
                            </div>
                        </div>

                        <div className="presentation_society_item">
                            <div className="society_name">
                                <img src={connect_icon4} alt=""/>
                                LinkedIn
                            </div>
                            <div className="society_link">
                                <a href="https://www.linkedin.com/in/ivan-negoda">
                                    Ivan Negoda
                                </a>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="bg_circles">
                    <img src={circles_bg} alt=""/>
                </div>

            </motion.div>
            <div className="footer_presentation">
                <img src={footer_logo} alt=""/>
                <hr/>
                <div className="copyright_present">
                    © 2025 Undura. Built for transparency.
                </div>
            </div>


        </div>
    );
};

export default Presentation;